import url from '../url'
import headers from '../headers'

export default {
	getAll (context, user_uid, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/devices/?size=${size}`,
			headers.bearer()
		)
	},
	getAllAvailable (context, user_uid, size = 999) {
		return context.$http.get(
			`${url}/users/${user_uid}/devices/available/?size=${size}`,
			headers.bearer()
		)
	},
	get (context, user_uid, device_id) {
		return context.$http.get(
			`${url}/users/${user_uid}/devices/${device_id}/`,
			headers.bearer()
		)
	},
	add (context, user_uid, model) {
		return context.$http.post(
			`${url}/users/${user_uid}/devices/`,
			model,
			headers.bearer()
		)
	},
	edit (context, user_uid, model) {
		return context.$http.put(
			`${url}/users/${user_uid}/devices/${model.id}/`,
			model,
			headers.bearer()
		)
	},
	delete (context, user_uid, device_id) {
		return context.$http.delete(
			`${url}/users/${user_uid}/devices/${device_id}/`,
			headers.bearer()
		)
	},
	admin: {
		whitelist: {
			getAll (context, offset = 0, size = 999) {
				return context.$http.get(
					`${url}/admins/devices/whitelist/?offset=${offset}&size=${size}`,
					headers.bearer()
				)
			},
			get (context, watch_id) {
				return context.$http.get(
					`${url}/admins/devices/whitelist/${watch_id}/`,
					headers.bearer()
				)
			},
			add (context, model) {
				return context.$http.post(
					`${url}/admins/devices/whitelist/`,
					model,
					headers.bearer()
				)
			},
			edit (context, model) {
				return context.$http.put(
					`${url}/admins/devices/whitelist/${model.id}/`,
					model,
					headers.bearer()
				)
			},
			delete (context, id) {
				return context.$http.delete(
					`${url}/admins/devices/whitelist/${id}/`,
					headers.bearer()
				)
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/devices.js